var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CTabs"},_vm._l((_vm.list),function(tab){return _c('div',{key:tab.name,class:['CTab', tab.name === _vm.active && 'active'],on:{"click":function($event){return _vm.tabChangeHandler(tab)}}},[_vm._v(" "+_vm._s(tab.title)+" "),(tab.name === _vm.active)?_c('span',{staticClass:"tip"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }